import PropTypes from 'prop-types';
import React, { useCallback, useContext, useState } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomValidation } from '@bingads-webui-react/validation';
import {
  Field,
  Input,
  Label,
} from '@fluentui/react-components';
import { maxSearchCid, minSearchCid } from '../../constants/maximums';
import { errorMessages } from '../../errors';
import { useSearchCustomerIdStyles } from '../../styles';

const SearchCustomerIdInternal = ({
  customerId,
  isDisabled,
  onChange,
  showError,
  updateValidation,
}) => {
  const i18n = useContext(I18nContext);
  const label = i18n.getString(_TL_('Add customer ID (optional)'));
  const placeholder = i18n.getString(_TL_('Enter the CID associated with your Search campaigns'));

  const styles = useSearchCustomerIdStyles();

  const [fieldProps, setFieldProps] = useState(null);

  const getIsValid = useCallback((data) => {
    if (data === '') {
      return { isValid: true };
    }
    if (!data) {
      return { errorMessage: errorMessages.SEARCH_CID_TYPE, isValid: false };
    }
    const formattedData = Number(data);
    if (formattedData < minSearchCid || formattedData > maxSearchCid) {
      return { errorMessage: errorMessages.SEARCH_CID_RANGE, isValid: false };
    }
    return { isValid: true };
  }, []);

  const onChangeInput = useCallback((e, data) => {
    const { errorMessage, isValid } = getIsValid(data.value);
    if (isValid) {
      setFieldProps(null);
      updateValidation([], { searchCid: data.value });
    } else {
      setFieldProps({
        validationMessage: i18n.getString(errorMessage),
        validationState: 'error',
      });
      updateValidation([errorMessage], { searchCid: data.value });
    }
    onChange(data.value);
  }, [getIsValid, i18n, onChange, updateValidation]);

  return (
    <div className="search-customer-id">
      <Label disabled={isDisabled}>{label}</Label>
      <Field {...(showError ? fieldProps : null)}>
        <Input
          className={styles.input}
          disabled={isDisabled}
          onChange={onChangeInput}
          placeholder={placeholder}
          value={customerId}
        />
      </Field>
    </div>
  );
};

SearchCustomerIdInternal.propTypes = {
  customerId: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  showError: PropTypes.bool,
  updateValidation: PropTypes.func.isRequired,
};

SearchCustomerIdInternal.defaultProps = {
  showError: false,
};

export const SearchCustomerId = withCustomValidation(SearchCustomerIdInternal);
